import type { ComposeViewState } from 'owa-mail-compose-store';
import type { MenuDefinition, MenuSection } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { MenuItemControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';
import { createGeneratedMenuItem } from 'owa-command-ribbon';
import { getRecipientWellsFromComposeViewState } from 'owa-mail-compose-actions/lib/utils/getAllRecipientsAsEmailAddressStrings';
import { tryAddRecipientFromEmailAddressString } from 'owa-mail-compose-actions/lib/utils/tryAddRecipientFromEmailAddressString';
import getCurrentFromAddress from 'owa-mail-compose-actions/lib/utils/getFromAddressFromRecipientWell';
import { lazyGetFluidMenuItems } from 'owa-fluid-integrations';
import { getDefaultRibbonStyles } from 'owa-command-ribbon-styles/lib/util/getDefaultRibbonStyles';
import { FluidOwaSource } from 'owa-fluid-validations';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';

const getFluidHeroControls = (
    viewState: ComposeViewState,
    targetWindow: Window
): MenuItemControlProps[] => {
    const composeParams = {
        getRecipientWells: () => getRecipientWellsFromComposeViewState(viewState),
        fromAddress: getCurrentFromAddress(viewState.toRecipientWell),
        linkIdContainer: viewState.attachmentWell,
    };
    const tryAddRecipientFunc = (emailAddress: string) => {
        tryAddRecipientFromEmailAddressString(viewState, emailAddress);
    };
    const subMenuProps = lazyGetFluidMenuItems.tryImportForRender()?.(
        FluidOwaSource.MailCompose,
        targetWindow,
        viewState,
        undefined /* targetDiv */,
        viewState.subject,
        composeParams,
        tryAddRecipientFunc,
        viewState.composeId
    );
    const noHandler = () => {};
    const controls: MenuItemControlProps[] = [];
    if (subMenuProps) {
        subMenuProps.items.forEach(subMenuItem => {
            controls.push(
                createGeneratedMenuItem(
                    getComposeRibbonId('fluidhero' + subMenuItem.key, viewState),
                    subMenuItem.name || '',
                    subMenuItem.onClick || noHandler,
                    undefined, // keyTipProps
                    subMenuItem.iconProps?.iconName,
                    undefined, // iconColor
                    getDefaultRibbonStyles()
                ) as MenuItemControlProps
            );
        });
    }
    return controls;
};

const getFluidHeroSections = (viewState: ComposeViewState, targetWindow: Window): MenuSection[] => {
    const sections: MenuSection[] = [];
    sections.push({ controls: getFluidHeroControls(viewState, targetWindow) });
    return sections;
};

const getFluidHeroMenuDefinition = (
    viewState: ComposeViewState,
    targetWindow: Window
): MenuDefinition => {
    return { sections: getFluidHeroSections(viewState, targetWindow) };
};

export default getFluidHeroMenuDefinition;
